import requestv2 from "~/utils/http-v2";

const permissionApi = {
    getPermission : async (params) => {
        const url = (params?.role) ? `v2/permission/${params?.role}` : 'v2/permission';
        return await requestv2.get(url, {params});
    },
    updatePermission : async (params) => {
        const url = `v2/permission/${params?.role}`;
        return await requestv2.post(url, params);
    },
};

export default permissionApi;